import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { generarReporteIdentidadUnoBeta } from "../api/generarReporteIdentidadUnoBeta";
import { generarImagenReporte } from "../api/generarImagenReporte";
import Modal from 'react-bootstrap/Modal';
import "./print.css";
import "./style.css";
import { jsPDF } from "jspdf";

function N1Beta() {

    const componentRef = useRef(null);
    const isRunned = useRef(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [modalShow, setModalShow] = useState(false);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [imagenFront, setImagenFront] = useState("");
    const [imagenBack, setImagenBack] = useState("");

    /*---Nombre reporte---*/

    const date = new Date();
    const formattedDate = date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');
    const [cpv, setCpv] = useState(params.get("i"));

    const [nombres, setNombres] = useState("");
    const [validacionNombre, setvalidacionNombre] = useState(false);

    const [vigencia, setVigencia] = useState("");
    const [primerApellido, setPrimerApellido] = useState("");
    const [segundoApellido, setSegundoApellido] = useState("");
    const [fechaNacimiento, setFechaNacimiento] = useState("");
    const [generoOficial, setGeneroOficial] = useState("");
    const [nacionalidades, setNacionalidades] = useState("");

    const [numeroCelular, setNumeroCelular] = useState("");
    const [correo, setCorreo] = useState("");

    const [facebook, setFacebook] = useState("");
    const [twitter, setTwitter] = useState("");
    const [instagram, setInstagram] = useState("");
    const [linkedin, setLinkedin] = useState("");

    const [anversoIne, setAnversoIne] = useState("");
    const [reversoIne, setReversoIne] = useState("");

    const [datosIdentificacion, setDatosIdentificacion] = useState("");
    const [datosContacto, setDatosContacto] = useState("");
    const [identidadAplicante, setIdentidadAplicante] = useState("");
    const [pruebaDeVida, setPruebaDeVida] = useState("");
    const [redesSociales, setRedesSociales] = useState("");
    const [alertasRiesgo, setAlertasRiesgo] = useState("");
    const [numIdentificacionNacionalNumero, setNumIdentificacionNacionalNumero] = useState("");
    const [numIdentificacionNacionalNombre, setNumIdentificacionNacionalNombre] = useState("");
    const [numIdentificacionNacionalEmisor, setNumIdentificacionNacionalEmisor] = useState("");

    const [numIdentificacionNacionalPais, setNumIdentificacionNacionalPais] = useState("");
    const [numIdentificacionNacionalEmitido, setNumIdentificacionNacionalEmitido] = useState("");
    const [numIdentificacionNacionalEstatus, setNumIdentificacionNacionalEstatus] = useState("");
    const [botonTendencia, setBotonTendencia] = useState(false);

    const [pasaporteCredencialTitulo, setPasaporteCredencialTitulo] = useState("");
    const [pasaporteCredencialNumero, setPasaporteCredencialNumero] = useState("");
    const [pasaporteCredencialNombre, setPasaporteCredencialNombre] = useState("");
    const [pasaporteCredencialEmisor, setPasaporteCredencialEmisor] = useState("");
    const [pasaporteCredencialPais, setPasaporteCredencialPais] = useState("");
    const [pasaporteCredencialVencimiento, setPasaporteCredencialVencimiento] = useState("");
    const [pasaporteCredencialEstatus, setPasaporteCredencialEstatus] = useState("");

    const [alertaProbidadTexto, setAlertaProbidadTexto] = useState("");
    const [alertaProalertaProbidadNivelbidadTexto, setAlertaProalertaProbidadNivelbidadTexto] = useState("");
    const [textoFooter, setTextoFooter] = useState("");
    const [alertaProbidadNivel, setAlertaProbidadNivel] = useState("");

    const [selfie, setSelfie] = useState("");
    const [cardSvgP, setCardSvgP] = useState("");
    const [logoDPR, setLogoDPR] = useState("");
    const [check_deepBlue, setCheck_deepBlue] = useState("");
    const [cardSvgBlack, setCardSvgBlack] = useState("");
    const [userExample, setUserExample] = useState("");
    const [fakeExample, setFakeExample] = useState("");
    const [fakeExample2, setFakeExample2] = useState("");
    const [qr, setQr] = useState("");
    const [observaciones, setObservaciones] = useState("");
    const [showBut, setShowBut] = useState(false);

    const handleClose = () => {
        setShow(false);
    }

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            localStorage.clear();

            if (params.get("i") == null) {

                setLoading(false);
                setModalShow(false);
                setShow(true);
                setShowStatus(500);
                setShowMessage("Error al obtener el cpv")

            } else {

                setLoading(true);

                const objCpv = {
                    cpv: params.get("i"),
                };

                const response = await generarReporteIdentidadUnoBeta(objCpv);

                if (response.status === 200) {

                    const cardSvgPStr =
                        "data:image/png;base64," + response.cardSvgP + "";

                    const logoDPRStr =
                        "data:image/png;base64," + response.logoDPR + "";

                    const check_deepBlueStr =
                        "data:image/png;base64," + response.check_deepBlue + "";

                    const cardSvgBlackStr =
                        "data:image/png;base64," + response.cardSvgBlack + "";

                    const userExampleStr =
                        "data:image/png;base64," + response.userExample + "";

                    const fakeExampleStr =
                        "data:image/png;base64," + response.fakeExample + "";

                    const fakeExample2Str =
                        "data:image/png;base64," + response.fakeExample2 + "";

                    const qrStr =
                        "data:image/png;base64," + response.qr + "";

                    const selfieStr = "" + response.selfie + "";

                    setCpv(response.cpv);

                    setNombres(response.nombres);
                    setVigencia(response.vigencia);
                    setPrimerApellido(response.primerApellido);
                    setSegundoApellido(response.segundoApellido);

                    if (response.nameFullCompleto === true) {
                        setvalidacionNombre(true);
                    }

                    setFechaNacimiento(response.fechaNacimiento);
                    setGeneroOficial(response.generoOficial);
                    setNacionalidades(response.nacionalidades);

                    setNumeroCelular(response.numeroCelular);
                    setFacebook(response.facebook);
                    setCorreo(response.correo);
                    setTwitter(response.twitter);
                    setInstagram(response.instagram);
                    setLinkedin(response.linkedin);
                    setTextoFooter(response.textoFooter);
                    setSelfie(selfieStr);
                    setAnversoIne(response.anversoIne);
                    setReversoIne(response.reversoIne);

                    setDatosIdentificacion(response.datosIdentificacion);
                    setDatosContacto(response.datosContacto);
                    setIdentidadAplicante(response.identidadAplicante);
                    setPruebaDeVida(response.pruebaDeVida);
                    setRedesSociales(response.redesSociales);
                    setAlertasRiesgo(response.alertasRiesgo);
                    setNumIdentificacionNacionalNumero(response.numIdentificacionNacionalNumero);

                    setNumIdentificacionNacionalNombre(response.numIdentificacionNacionalNombre);
                    setNumIdentificacionNacionalPais(response.numIdentificacionNacionalPais);
                    setNumIdentificacionNacionalEmisor(response.numIdentificacionNacionalEmisor);
                    setNumIdentificacionNacionalEmitido(response.numIdentificacionNacionalEmitido);
                    setNumIdentificacionNacionalEstatus(response.numIdentificacionNacionalEstatus);

                    setPasaporteCredencialTitulo(response.pasaporteCredencialTitulo);
                    setPasaporteCredencialNumero(response.pasaporteCredencialNumero);
                    setPasaporteCredencialNombre(response.pasaporteCredencialNombre);
                    setPasaporteCredencialEmisor(response.pasaporteCredencialEmisor);
                    setBotonTendencia(response.inconsistente);

                    setPasaporteCredencialPais(response.pasaporteCredencialPais);
                    setPasaporteCredencialVencimiento(response.pasaporteCredencialVencimiento);
                    setPasaporteCredencialEstatus(response.pasaporteCredencialEstatus);
                    setAlertaProbidadTexto(response.alertaProbidadTexto);
                    setAlertaProbidadNivel(response.alertaProbidadNivel);
                    setAlertaProalertaProbidadNivelbidadTexto(response.alertaProalertaProbidadNivelbidadTexto);
                    setTextoFooter(response.textoFooter);

                    setUserExample(userExampleStr);
                    setLogoDPR(logoDPRStr);
                    setCardSvgP(cardSvgPStr);
                    setCheck_deepBlue(check_deepBlueStr);
                    setCardSvgBlack(cardSvgBlackStr);
                    setFakeExample(fakeExampleStr);
                    setFakeExample2(fakeExample2Str);
                    setQr(qrStr);

                    setShowBut(true);
                    setLoading(false);

                    handlePrint();

                } else {

                    setLoading(false);
                    setShow(true);
                    setShowStatus(response.status);
                    setShowMessage(response.message);

                }

            }

        }

        createSession();

    }, []);


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        print: async () => {
            const doc = new jsPDF();
            doc.html(componentRef.current, {
                html2canvas: {
                    removeContainer: true,
                    scale: 0.19
                },
                margin: 5,
                x: -1,
                async callback(doc) {
                    await doc.save('Verificación de autenticidad ' + cpv + '_' + formattedDate);
                },
            });
        },

    });

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>


            <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
                <div
                    className=" animate__animated animate__fadeIn"
                    ref={componentRef}
                    style={{ display: "flex", width: "1070px", border: "none" }}
                >
                    <div className="relativeCSS">
                        <style type="text/css" media="print">
                            {
                                "@page {  size: A4;  }"
                            }
                        </style>

                        {/* hoja 1 */}
                        <br />
                        <div className="container-fluid">
                            <section className="row">
                                <div className="col-6">
                                    <article className="identify-card ">
                                        <aside className="account-detail gray w25">
                                            <section className="detail-image">
                                                <img src={logoDPR} alt="" />
                                            </section>
                                            <div className="detail-background">
                                                <img src={cardSvgP} alt="" width={'75%'} height={'auto'} />
                                            </div>
                                        </aside>
                                        <article className="middle-section">
                                            <title className="title">
                                                <div className="left">IDe</div>
                                                <div className="right">
                                                    <strong>IDENTIDAD ELECTRÓNICA</strong>
                                                    <br />
                                                    <span>CREDENCIAL VERIFICABLE</span>
                                                </div>
                                            </title>
                                            <section className="info-section gray">
                                                <div className="subtitle">
                                                    <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                                                    <h2>Identidad</h2>
                                                    <h4>Nivel 1</h4>
                                                </div>
                                                <hr className="bordeHr" />
                                                <ul className="pNone">
                                                    <li>
                                                        <img src={check_deepBlue} alt="checkBlue" />
                                                        <span>AUTENTICACIÓN &nbsp; DE IDENTIDAD</span>
                                                    </li>
                                                    <li>
                                                        <img src={check_deepBlue} alt="checkBlue" />
                                                        <span>DOCUMENTACIÓN &nbsp; PROBATORIA</span>
                                                    </li>
                                                    <li>
                                                        <img src={check_deepBlue} alt="checkBlue" />
                                                        <span>ALERTAS &nbsp; DE PROBIDAD</span>
                                                    </li>
                                                </ul>
                                                <div className="expires">
                                                    <span className="text-lg">Vence: {vigencia}</span>
                                                </div>
                                            </section>
                                        </article>
                                        <article className="right-section">
                                            <div className="detail-finance identity">
                                                <img src={cardSvgBlack} alt="" className="w50px" />
                                            </div>
                                            <section className="qr-code">
                                                <img className="w50px" src={qr} alt="" />
                                                <span className="cpv__text">CPV&nbsp;: {cpv}</span>
                                            </section>
                                            <section className="verify">
                                                <img src={cardSvgP} alt="" />
                                            </section>
                                        </article>
                                    </article>

                                    <br />

                                    <div className="titleCard">Verificación &nbsp; de autenticidad</div>
                                    <div className="card verify-note">
                                        <p className="f12"> El resultado obtenido  <strong> no es válido </strong> si la fecha en la parte superior izquierda de este
                                            <strong> Reporte </strong> se encuentra <strong> vencida </strong> . Para comprobar su autenticidad escanee el código QR o ingrese directamente el código
                                            <strong> CPV </strong> en <strong> www.midpr.net/verificar </strong> .
                                        </p>
                                    </div>
                                    <small className="footer-note">
                                        *Notifique si este Reporte es falso al +52 5571605526 y/o en www.midpr.net
                                    </small>
                                </div>
                                <div className="col-6">
                                    <h4 className="text-center">Accesibilidad Digital</h4>
                                    <p className="f12">
                                        Este <strong>&nbsp; Reporte </strong>
                                        da constancia de la calificación resultante de la aplicación de manera
                                        <strong> completa y concluyente </strong>
                                        de esta Evaluación Remota Confiable (ERC&nbsp;) realizada por el
                                        <strong> Aplicante </strong>
                                        , obteniendo los siguientes resultados:
                                    </p>
                                    <div className="titleCard">Resultado &nbsp; obtenido</div>
                                    <article className="card digital-data">
                                        <table>
                                            <tbody>
                                                <tr className="dataResulObj"><span>Datos de identificación: <strong>{datosIdentificacion}</strong></span></tr>
                                                <tr className="dataResulObj"><span>Datos de contacto: <strong>{datosContacto}</strong></span></tr>
                                                <tr className="dataResulObj"><span>Identidad del aplicante: <strong>{identidadAplicante}</strong></span> </tr>
                                                <tr className="dataResulObj"><span>Prueba de vida: <strong>{pruebaDeVida}</strong></span></tr>
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-center  align-items-center">
                                            <button type="button" className="inter">Alertas de Riesgo&nbsp;: {alertasRiesgo}</button>
                                        </div>


                                    </article>
                                    <small className="footer-note">
                                        *La interpretación de este resultado obtenido es responsabilidad exclusiva de quien lo recibe.
                                    </small>
                                </div>
                            </section>

                        </div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6 personal-data">
                                    <br />
                                    <div className="titleCard">DATOS &nbsp; PERSONALES</div>
                                    <section className="card  container-fluid ">
                                        <div className="row">
                                            <div className="col-4">
                                                <img src={selfie} alt="userPicture" className="Card__userPic" />
                                            </div>
                                            <div className="col-8">
                                                <div className="personal-info f13">
                                                    <address>

                                                        {validacionNombre ? (
                                                            <>
                                                                <div>Nombres: <strong>{nombres}</strong></div>
                                                                <div>Primer apellido: <strong>{primerApellido}</strong></div>
                                                                <div>Segundo apellido&nbsp;:<strong>{segundoApellido}</strong></div>

                                                            </>
                                                        ) : (
                                                            <>
                                                                <div>Nombre: <strong>{nombres}</strong></div>
                                                            </>
                                                        )}


                                                        <div>Fecha de nacimiento&nbsp;: {fechaNacimiento}</div>
                                                        <div>Género oficial: {generoOficial}</div>
                                                        <div>Nacionalidad: {nacionalidades}</div>
                                                    </address>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <h5 className="tiny">Datos de Contacto</h5>
                                    <address className="no-card f14">
                                        <div>Número de celular: <strong>{numeroCelular}</strong>&nbsp;(&nbsp;activo&nbsp;)</div>
                                    </address>

                                    {!botonTendencia ? (
                                        <>
                                            <div>
                                                <div className=" d-flex justify-content-center align-items-center">
                                                    <button type="button" className="btn green trend">TENDENCIA &nbsp; A &nbsp; CONSISTENTE</button>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div>
                                                <div className=" d-flex justify-content-center align-items-center">
                                                    <button type="button" class="btn yellow trend">TENDENCIA &nbsp; A INCONSISTENTE</button>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <small className="footer-note">*Consulte definiciones de estas métricas en www.midpr.net/resultados</small>
                                    <div className="f12 p15">
                                        Esta <strong> &nbsp; IDe </strong>
                                        fue realizada de manera automatizada a través de un dispositivo digital propiedad del
                                        <strong> Aplicante </strong>
                                        . Durante el proceso, se registraron una serie de datos de carácter personal que fueron analizados, validados y/o verificados que permitieron, posterior al análisis de la información, la obtención del dictamen presentado con respecto a la consistencia o inconsistencia de estos de manera integral.

                                    </div>
                                </div>
                                <div className="col-6 ">
                                    <br />
                                    <div className="titleCard">Áreas &nbsp; evaluadas</div>
                                    <div className="card probation">
                                        <div className="f15">Número de Identificación Nacional</div>
                                        <address className="f12">
                                            <div>Número &nbsp;<strong>{numIdentificacionNacionalNumero}</strong></div>
                                            <div>Nombre: {numIdentificacionNacionalNombre}</div>
                                            <div>Emisor: {numIdentificacionNacionalEmisor}</div>
                                            <div>País: {numIdentificacionNacionalPais}</div>
                                            <div>Emitido: {numIdentificacionNacionalEmitido}</div>
                                            <div>Estatus: {numIdentificacionNacionalEstatus}</div>
                                        </address>
                                        <div className="f15">{pasaporteCredencialNombre}</div>
                                        <address className="f12">
                                            <div>Número: &nbsp; <strong>{pasaporteCredencialNumero}</strong></div>
                                            <div>Nombre: {pasaporteCredencialTitulo}</div>
                                            <div>Emisor: {pasaporteCredencialEmisor}</div>
                                            <div>País: {pasaporteCredencialPais}</div>
                                            <div>Vence: {pasaporteCredencialVencimiento}</div>
                                            <div>Estatus&nbsp;: {pasaporteCredencialEstatus}</div>
                                        </address>
                                    </div>
                                    <small className="footer-note">*Consulte al reverso de este Reporte las imágenes recabadas.</small>
                                    <div className="titleCard">ALERTAS &nbsp;  DE PROBIDAD</div>
                                    <section className="card family-income f12">
                                        <p> {alertaProbidadTexto}</p>
                                        <h6><strong>{alertaProbidadNivel}</strong></h6>
                                    </section>
                                </div>
                            </div>
                        </div>
                        <section className="note-gray note-emit">
                            <p> {textoFooter}</p>
                        </section>
                        <small className="footer-note">*Consulte al reverso de este Reporte DPR &nbsp; nuestra Política de Privacidad y/o en www.midpr.net/privacidad</small>
                        <div className="titleCard">AVISO &nbsp; LEGAL</div>
                        <div class="card legal-advise">
                            <p className="f12">La <strong>&nbsp;Calificación&nbsp;</strong> realizada de manera remota por el <strong>Aplicante</strong>, a la que hace referencia este <strong>Reporte</strong>, fue realizada a solicitud directa del <strong>Destinatario</strong>. Antes y durante la <strong>Calificación</strong>, fue autenticada la identidad del <strong>Aplicante</strong> y se registraron una serie de datos e información de carácter personal con su autorización expresa, lo cual permitió emitir una Evaluación Remota Confiable (&nbsp; ERC &nbsp;). El <strong>Destinatario</strong> acepta que todos los datos contenidos en el presente <strong>Reporte</strong> son confidenciales y de interés exclusivo y privado, que es compartida únicamente con el propósito que ha sido previamente informado por el <strong>Destinatario</strong> y que ha autorizado por el <strong>Aplicante</strong> previo a la aplicación de la <strong>Calificación</strong>. El <strong>Aplicante</strong> y/o el <strong>Destinatario</strong> de este Reporte aceptan de conformidad la responsabilidad sobre cualquier uso indebido o ilegal de este documento y su contenido, así como todos los términos y condiciones descritos al reverso. <strong>Una vez entregado este Reporte al Destinatario, el Fabricante se deslinda de toda responsabilidad sobre su interpretación, divulgación y uso</strong>.</p>
                            <br />
                        </div>
                        <br />
                        <p class="txt-center f12"><strong>Business &nbsp; Prey SA de CV</strong> hace referencia que con número de registro <strong>DGSP&nbsp;/369-19/3919</strong>, está autorizada por la <strong>SSPC&nbsp;/DGSP</strong> para la aplicación de Pruebas y Evaluación de Control de Confianza de conformidad con los <strong>Lineamientos y Criterios Técnicos&nbsp;</strong> publicados en el Diario Oficial de la Federación (DOF) el <strong>28 de abril de 2020</strong>.</p>


                        {/* hoja 2 */}

                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />





                        <div className="titleCard">DOCUMENTOS &nbsp; PRESENTADOS</div>
                        <div className="card presented  ContainerCardIne ">
                            <div className="row justify-content-center m1  h-100 align-items-center">
                                <div className="col-6 d-flex justify-content-center  h-100">
                                    <img src={anversoIne} alt="" className="PassPort--sizing w-100 " />

                                </div>
                                <div className="col-6 d-flex justify-content-center h-100">

                                    <img src={reversoIne} alt="" className="PassPort--sizing w-100" />
                                </div>
                            </div>
                        </div>

                        <div className="titleCard">OBSERVACIONES&nbsp;</div>
                        <div className="card observations empty">
                            <p>{observaciones}</p>
                        </div>

                        <div className="div-vertical">
                            <div className="div-horizontal pTop15">

                                <div className="cardLeft">
                                    <div className="subTitleCardTwo">
                                        <b>Business Prey SA de CV (BP)</b>, Fabricante exclusivo en la
                                        República Mexicana para DPR, con número de registro
                                        autorización DGSP/369-19/3919 expedido por la Dirección
                                        General de Seguridad Privada (DGSP) &nbsp; de la Secretaría de
                                        Seguridad y Protección Ciudadana (SSPC) &nbsp; para la aplicación
                                        de pruebas de evaluación de control de confianza en
                                        términos de los Lineamientos y Criterios Técnicos que
                                        deberán cumplir las Empresas de Seguridad Privada bajo la
                                        Modalidad VI, previsto en el artículo 15 de la Ley Federal
                                        de Seguridad Privada (LFSP), publicados con fecha de 28 de
                                        abril de 2020, en el Diario Oficial de la Federación (DOF)
                                        y en cumplimiento con lo dispuesto por los artículos 1, 3,
                                        6, 7, 8, 12 y 14 de la Ley Federal de Protección de Datos
                                        Personales en Posesión de los Particulares emite el
                                        resultado de la presente Evaluación Remota Confiable
                                        (ERC).
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>Aplicación de la Evaluación ERC &nbsp;</b> La presente ERC &nbsp; fue
                                        acotada a una Área de Interés específica mediante un
                                        proceso remoto que el Aplicante aceptó de manera expresa y
                                        totalmente voluntaria someterse a la evaluación, con la
                                        finalidad de ser calificado en diversas Temáticas con lo
                                        que se estimó el Resultado Obtenido, conforme a la
                                        metodología y marcos de referencia establecidos por DPR
                                        para tal efecto. Para la realización de la ERC, el
                                        Aplicante utiliza dispositivos electrónicos de su
                                        propiedad, fuera del control del Fabricante, por lo que se
                                        aplican avanzados métodos de validación y verificación de
                                        datos para asegurar su veracidad y autenticidad.
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>Declaración de Veracidad &nbsp;</b> Esta evaluación ERC &nbsp; puede o no
                                        formar parte de un proceso de certificación que incluye
                                        una Prueba DPR. Al presentar esta ERC, el Aplicante acepta
                                        y se somete a una declaración bajo protesta de decir
                                        verdad de proporcionar información fidedigna. La veracidad
                                        de la misma puede ser comprobada durante o posteriormente.
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>Proceso de Calificación</b> La ERC incluye un conjunto de
                                        Áreas Evaluadas que incluyen Temas de Interés que son
                                        requisitados para obtener un Resultado y un Dictamen. La
                                        información que se recaba y se procesa durante la
                                        evaluación se describen en este Reporte y corresponden a
                                        una dimensión particular de datos adquiridos del
                                        Aplicante.
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>Interpretación de los Resultados</b> Esta ERC incluye los
                                        diversas Temas de Interés para obtener un Resultado
                                        Obtenido y el Dictamen de veracidad o congruencia, que son
                                        exclusivamente un parámetro medido en porcentaje y/o una
                                        valoración cualitativa correspondientemente, por lo que no
                                        existe un valor o magnitud específica que sea aprobatoria
                                        o no aprobatoria. Es responsabilidad exclusiva del
                                        Destinatario establecer el umbral mínimo o máximo
                                        esperado, para la determinación de la aceptación del
                                        Aplicante o para la permanencia de acuerdo a los
                                        Resultados Obtenidos.
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>Emisión del Certificado</b> Al culminar de manera concluyente
                                        esta ERC, el resultado se procesa en un periodo máximo de
                                        24 horas. El resultado, datos y dictamen descrito en este
                                        Reporte, es sellado digitalmente mediante un Certificado
                                        Personal Verificable (CPV) de forma numérica o en QR que
                                        puede ser utilizado para confirmar la vigencia y
                                        autenticidad del mismo en la página
                                        www.midpr.net/verificar. Este Reporte deberá ser
                                        considerado como falso, si la consulta no resulta en la
                                        leyenda de “Verificado”.
                                    </div>
                                </div>
                                <div>
                                    <div className="subTitleCardTwo">
                                        <b>Privacidad de Datos Personales &nbsp;</b> Para efectos del
                                        cumplimiento del artículo 9 de la Ley Federal de
                                        Protección de Datos Personales en Posesión de los
                                        Particulares (LFPDPPP), el Aplicante de la ERC manifiesta
                                        expresamente que otorgó su consentimiento para el
                                        tratamiento de sus datos personales sensibles, durante los
                                        procedimientos de recopilación y procesamiento, aceptando
                                        los términos y condiciones para tales efectos.
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>Uso de las Marcas</b> DPR y las marcas asociadas son marcas
                                        registradas, protegida por los artículos 88 y 142 de la
                                        Ley de Propiedad Industrial (LPI), así como el convenio de
                                        París para efectos internacionales. El consumo o
                                        adquisición de cualquiera de los servicios vinculados a
                                        DPR y/o proporcionados por el Fabricante, no confieren al
                                        Aplicante y/o al Destinatario el derecho de uso de las
                                        marcas de DPR en ningún contexto y/o formato, ya que al
                                        hacerlo podría resultar en actividad fraudulenta y ser
                                        clasificado como un delito. La marca, propiedad
                                        intelectual o cualquier otro tipo de secreto industrial
                                        contenido en este Reporte, no autoriza el uso, explotación
                                        comercial, venta, reproducción o distribución de dicha
                                        información.
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>Uso de Información por Terceros &nbsp;</b> Al realizar la ERC, el
                                        Aplicante autoriza la entrega del resultado obtenido al
                                        Destinatario para el uso particular que ambos hayan
                                        acordado. Para el caso exclusivo de Elementos de Seguridad
                                        Privada, la entrega de este Reporte a la DGSP, se hará
                                        conforme a lo previsto en el artículo 9 de los citados
                                        Lineamientos y Criterios Técnicos.
                                    </div>

                                    <div className="subTitleCardTwo">
                                        <b>
                                            En DPR estamos a favor de la confianza profesional, la
                                            honestidad y transparencia, la privacidad de datos
                                            personales, la equidad de género, la inclusión financiera
                                            y digital, la igualdad de oportunidades y la no
                                            discriminación.
                                        </b>
                                    </div>

                                    <div className="card evaluated-areas tipo-d borderCard">
                                        <div className="titleContainerSinBorder">
                                            TEMAS DE INTERÉS
                                        </div>
                                        <div className="subTitleCardTwo">
                                            <ul className="espacio-ul-left">
                                                <li><strong>Datos de Identificación:</strong> Nacionalidad (verificada), Número de Identificación Nacional (verificado), Credencial de Identidad Nacional (verificada) y/o Pasaporte (validado).</li>
                                                <li><strong>Datos de Contacto:</strong> Número celular (validado) y/o correo electrónico personal (validado) y/o correo electrónico laboral (validado), antigüedad de correos (opcional), redes sociales (recabadas).</li>
                                                <li><strong>Autenticación de Identidad:</strong> Fotografía frontal (verificada), reconocimiento facial (verificado), prueba de vida (verificada).</li>
                                                <li><strong>Alertas de probidad:</strong> Sanciones, alertas internacionales.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <div className="note-gray">
                                        <p>
                                            <strong>Business Prey SA de CV</strong> con domicilio en
                                            Alfonso Reyes 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                                            DPR. Para mayor información llame al +52 5571605526 o
                                            visite el sitio <strong>www.midpr.net</strong>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default N1Beta;
